import { createRequestActionTypes } from '../../helpers'

export const FETCH_FAQ = createRequestActionTypes('FAQ', 'FAQ')
